import { ISO_4217 } from "../../iso-4217";
import { event, GtagEvent } from "./event";
import { Item } from "./item";

export interface BeginCheckout extends GtagEvent {
    currency:ISO_4217;
    value: number;
    coupon?:string;
    items:Item[]
}
export const begin_checkout = ($_:BeginCheckout) => event('begin_checkout',$_);